import { log } from '../logger/logger.js';
import { logPerf } from './log.js';
import { serialise } from './serialise.js';

const fallbackDuration = -1;
const getId = () => Math.trunc(Math.random() * 1679615).toString(36).padStart(4, "0");
const startPerformanceMeasure = (subscription, name, action) => {
  try {
    const measureName = serialise({ subscription, name, action });
    const markName = `${measureName}-${getId()}`;
    const start = performance.now();
    performance.mark(markName);
    const endPerformanceMeasure = () => {
      try {
        const { duration } = window.performance.measure(
          measureName,
          markName
        ) ?? {
          duration: performance.now() - start
        };
        const formattedDuration = Math.ceil(duration);
        logPerf(measureName, formattedDuration);
        return formattedDuration;
      } catch (error) {
        log(subscription, error);
        return fallbackDuration;
      }
    };
    return { endPerformanceMeasure };
  } catch (error) {
    log(subscription, error);
    return { endPerformanceMeasure: () => fallbackDuration };
  }
};

export { startPerformanceMeasure };
